module.exports = __webpack_public_path__ + "static/img/2.1.1-1.72a8836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/2.1.1-1.png
// module id = 9hit
// module chunks = 1